var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33273 2.22349C4.89959 1.44068 5.99371 1.26562 6.77652 1.83248L14.0265 7.08248C14.8093 7.64935 14.9844 8.74347 14.4175 9.52628C13.8507 10.3091 12.7565 10.4841 11.9737 9.91728L4.72373 4.66728C3.94093 4.10042 3.76587 3.0063 4.33273 2.22349ZM19.1501 11.1999C19.73 11.9731 19.5733 13.07 18.8001 13.6499L6.80013 22.6499C6.02693 23.2298 4.93003 23.0731 4.35013 22.2999C3.77023 21.5267 3.92693 20.4298 4.70013 19.8499L16.7001 10.8499C17.4733 10.27 18.5702 10.4267 19.1501 11.1999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrow);
export default __webpack_public_path__ + "static/media/ic_arrow.af2e24a3816f5f36ee51a5d80f6ef2cd.svg";
export { ForwardRef as ReactComponent };